import { render, staticRenderFns } from "./dipatch-recommend.vue?vue&type=template&id=3acb239e&"
import script from "./dipatch-recommend.vue?vue&type=script&lang=js&"
export * from "./dipatch-recommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports